__turbopack_context__.v({
  "active": "environment-select-module-scss-module__3O2KJa__active",
  "group": "environment-select-module-scss-module__3O2KJa__group",
  "option": "environment-select-module-scss-module__3O2KJa__option",
});
